import { closeSvg } from "../assets/icons";

interface CloseModalIconProps {
  onRequestClose: () => void;
}

export const CloseModalIcon = ({ onRequestClose }: CloseModalIconProps) => {
  return (
    <div className="closeModalIconContainer">
      <button
        type="button"
        onClick={() => onRequestClose()}
        aria-label="Close modal"
      >
        <img src={closeSvg} alt="" aria-hidden="true" className="icon" />
      </button>
    </div>
  );
};
